import React from 'react'
import { FormattedMessage } from 'react-intl'
import { toRoman } from 'helpers'

import { UNIT_TYPES } from 'constants'

export const SQUAD_OF_MY_CLAN = (
    <FormattedMessage
        id='battle_rooms.unit_preview.squad_of_my_clan'
        defaultMessage='Отряд моего клана'
    />
)

export const UNIT_DESTROYED = (
    <FormattedMessage
        id='battle_rooms.unit_preview.destroyed'
        defaultMessage='Отряд расформирован'
    />
)

export const UNIT_DESCRIPTION = (unitType, vehicleLevel, peripheryName) => {
    const descriptions = {
        [UNIT_TYPES.SORTIE]: (
            <FormattedMessage
                id='battle_rooms.unit_preview.unit_sortie_description'
                defaultMessage='Вылазка в {vehicleLevel} дивизионе на сервере {peripheryName}'
                values={{ vehicleLevel: toRoman(vehicleLevel), peripheryName }}
            />
        ),
        [UNIT_TYPES.FORT_BATTLE]: (
            <FormattedMessage
                id='battle_rooms.unit_preview.unit_fort_battle_description'
                defaultMessage='Наступление на сервере {peripheryName}'
                values={{ peripheryName }}
            />
        ),
    }

    return descriptions[unitType]
}

export const TO_UNIT_MATCHING = (
    <FormattedMessage
        id='battle_rooms.unit_preview.to_unit_matching'
        defaultMessage='К подбору отряда'
    />
)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/UnitPreview/constants.jsx